import Dialog from '@/components/Dialog';
import Space from '@/components/Space';
import EditorIsReadonlyContext from '@/pages/EditorPage/ChallengeModelsEditor/EditorIsReadonlyContext';
import { Button, IconButton } from '@mui/material';
import { useContext, useState } from 'react';
import TagsManager from './TagsManager';
import {
  StyleOutlined as TagsIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import TagsDialog from './TagsDialog';
import FormattedMessageWithChallengeNaming from '@/components/FormattedMessageWithChallengeNaming';
import { FormattedMessage } from 'react-intl';

const TagsEditor = () => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const editorIsReadonly = useContext(EditorIsReadonlyContext);

  return (
    <>
      <Space height={12} />
      <Button
        variant="outlined"
        size="small"
        color="secondary"
        onClick={() => setDialogOpen(true)}
        startIcon={<TagsIcon />}
        disabled={editorIsReadonly}
        fullWidth
      >
        <FormattedMessage id="editor.model_editor.field_editor.tags_editor.manage_button" />
      </Button>
      <TagsDialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <Dialog.Title>
          <FormattedMessage id="editor.model_editor.field_editor.tags_editor.dialog.title" />
          <IconButton onClick={() => setDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedMessageWithChallengeNaming
              id="editor.model_editor.field_editor.tags_editor.dialog.text"
              hasHtml
            />
          </Dialog.ContentText>
        </Dialog.Content>
        <TagsManager />
      </TagsDialog>
    </>
  );
};

export default TagsEditor;
